<template>
  <div class="Preliminary">
    <div class="ozaria" v-if="user.group !== 5">
      <div class="title">
        <img alt="" :src="cocoLogo.icon"/>
        <div>
          风暴围城
        </div>
      </div>
      <div class="buttn" v-if="finished.ozaira">已完成</div>
      <div class="buttn" v-else @click="start('ozaria')" :disable="!playUrl">开始挑战</div>
      <!-- <div class="play" @click="video('ozaria')"></div> -->
      <div class="desc">在风暴围城竞技场获得正分</div>
    </div>
    <div class="codecombat" v-else>
      <div class="title">
        <img alt="" :src="cocoLogo.icon"/>
        <div>
          沙滩精灵
        </div>
      </div>
      <div class="buttn" v-if="finished.codecombat">已完成</div>
      <div class="buttn" v-else @click="start('codecombat')">开始挑战</div>
      <div class="desc">在沙滩精灵地图中完成所有关卡</div>
    </div>
    <div class="video" v-if="playVideo">
      <video :src="videoSrc" controls controlsList="nodownload">
      </video>
      <div class="close" @click="playVideo=false">×</div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import MyImage from '@/components/Image.vue';
import MyVideo from '@/components/Video.vue';
import MyButton from '@/components/Button.vue';
import VueMarkdown from 'vue-markdown'
import rulemd from 'raw-loader!@/assets/markdown/repechargeRule.md';
import moment from 'moment'
export default {
  name: '',
  computed: {
     cocoLogo () {
       return this.$store.state.logo.coco
     },
    finished (){
      return {
        ozaira: false,
        codecombat: false
      }
    },
    user() {
      return this.$store.state.auth.user
    }
  },
  data () {
    return {
      disable: true,
      interval: null,
      playVideo: false,
      playUrl: '',
      videoSrc: '/oss/videos/3.%E4%BB%BB%E5%8A%A1%E4%BA%8C-%E6%89%A3%E5%93%92%E4%B8%96%E7%95%8C.mp4'
    }
  },
  methods: {
    start(c) {
      console.log('start', c)
      if(c == 'codecombat') {
        const url = '/play/65c56663d2ca2055e65676af?course=65f32b6c87c07dbeb5ba1936&course-instance=66b6c9a366311b207d9d9340'
        window.open(this.$store.state.gamelink+this.$store.state.auth.token.token + `&redirect=${encodeURIComponent(url)}`)
      }
      else
      {
        window.open(this.$store.state.gamelink+this.$store.state.auth.token.token + `&redirect=${encodeURIComponent(this.playUrl)}`)
      }
    },
    jump() {
      /* let user = this.user ||  this.$store.state.auth.user
       * let redirect = myClassroom.entry
       * let url = this.$store.state.loginLink + `&redirect=${encodeURIComponent(redirect)}` + `&accessToken=${this.$store.state.auth.token.token}`
       * window.open(url) */
    },
    video (src) {
      if(src == 'ozaria')
      {
        this.videoSrc = '/oss/videos/2021/%E4%BB%BB%E5%8A%A1%E9%A1%B5%E8%A7%86%E9%A2%91%E5%B7%A6-%E5%B7%AB%E5%B8%88%E4%B9%8B%E6%88%98.mp4'
      }
      else
      {
        this.videoSrc = '/oss/videos/3.%E4%BB%BB%E5%8A%A1%E4%BA%8C-%E6%89%A3%E5%93%92%E4%B8%96%E7%95%8C.mp4'
      }
      this.playVideo = true;
    },
    correctTime() {
      return moment(+new Date() + this.$store.state.timeDelay)
    },
  },
   mounted (){
     this.$http.get('/api/ladder/url').then(res => {
       this.playUrl = res.data
     })
   },
  components: {
    my_image: MyImage,
    my_video: MyVideo,
    my_button: MyButton,
    vue_markdown: VueMarkdown,
  }
}
</script>

<style scoped>
.Preliminary{
  display: flex;
  align-items: center;
  justify-content:space-around;
  font-size: 30px;

  width: 100vw;
  height: 100vh;
  /* background: linear-gradient(45deg, #58adac, #345d7c ); */
background: linear-gradient(45deg, #c82f00, #251e9e);
  background-size: 100vw;
  position: relative;
}
.ozaria, .codecombat{
  height: 90vh;
  display: flex;
  flex-direction: column;
  align-items:center;
}
/* .ozaria{
   margin-left: 3.5vw;
   width: 43.5vw;
   }
   .codecombat{
   margin-left: 3.3vw;
   width: 45.5vw;
   } */
.buttn{
  cursor: pointer;
  text-align: center;
  background-image: url(/oss/images/preliminary/button-start.png);
  background-size: 7em;
  width: 7em;
  height: 2em;
  line-height: 2em;
  margin-top: 30vh;
}
.play {
  width: 2em;
  height: 2em;
  /* background-image: url(/oss/images/preliminary/button-play.png); */
  background-size: 2em;
  margin-top: 20vh;
  cursor:pointer;
}
.desc{
  color: white;
  font-size: 18px;
  width: 30em;
  text-align:center;
  margin-top: 20px;
}
.video{
  position: absolute;
  width: 100vw;
  height: 100vh;
  top: 0vh;
  border-top: 5vh solid rgba(0,0,0, 0.1);
  display: flex;
  align-items:center;
  justify-content:center;
  background: rgba( 0,0,0, 0.7);
}
.video video{
  width: 80vw;
}
.video .close{
  font-size: 50px;
  position: absolute;
  color: white;
  right: 8vw;
  top: 2vw;;
  cursor: pointer;
}
.title {
  font-size: 120px;
  color: #f1a730;
  font-family: 'STXingkai';
  text-align: center;
  margin-top: 10vh;
  margin-bottom: 10vh;
}
</style>
